module.exports = __webpack_public_path__ + "static/img/sy_bg1.46cd75d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sy_bg1.jpg
// module id = 7XGq
// module chunks = 181